import {wechatService} from "@/services/wechat";
import {isWeixin} from "@/lib/util";
import {appidConfigCache} from "@/lib/cache";

export const wechatMixin = {
  data() {
    return {}
  },
  async mounted() {
    if (isWeixin())
      await wechatService.showMenuItems(this.appid);
  },
  async beforeDestroy() {
    if (isWeixin())
      await wechatService.hideMenuItems(this.appid);
  },
}



// WEBPACK FOOTER //
// ./src/lib/mixins/wechat.js